import React from "react";
import icons from "../constants/icons.ts";

const TestimonialCard = ({ name, title, content, avatar, rating = 5 }) => {
  return (
    <div className="card flex flex-col h-full">

      {/* Testimonial Content */}
      <p className="font-rubik font-light text-gray-700 mb-4 italic flex-1">
        "{content}"
      </p>

      {/* Rating */}
      <div className="mb-3">
        {[...Array(rating)].map((_, i) => (
          <i key={i} className={`${icons.rating.star} text-primary text-sm`}></i>
        ))}
      </div>

      {/* Author Info */}
      <div className="flex items-center gap-3 border-t pt-4">
        {avatar && (
          <img
            src={avatar}
            alt={name}
            className="w-12 h-12 rounded-full border-2 border-primary"
          />
        )}
        <div>
          <h4 className="font-rubik font-bold text-secondary">{name}</h4>
          <p className="font-rubik font-light text-xs text-gray-600">{title}</p>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
